var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checklist)?_c('v-container',{staticClass:"white",attrs:{"id":"print-wrapper"}},[_c('checklist-view',{attrs:{"checklist":_vm.checklist}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }